module.exports = __webpack_public_path__ + "media/customizations/camelback/logo-15600f006f16c0dbfbc2f38f936105e6.png";